import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWorkspaceFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 16,
	viewBox: "0 0 16 16",
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m14 3h-2v-1c0-1.09375-.9062-2-2-2h-4c-1.125 0-2 .90625-2 2v1h-2c-1.125 0-2 .90625-2 2v8c0 1.125.875 2 2 2h12c1.0938 0 2-.875 2-2v-8c0-1.09375-.9062-2-2-2zm-8-1.5h4c.25 0 .5.25.5.5v1h-5v-1c0-.25.21875-.5.5-.5zm-4 3h12c.25 0 .5.25.5.5v3h-13v-3c0-.25.21875-.5.5-.5zm12 9h-12c-.28125 0-.5-.2188-.5-.5v-3.5h4.5v.5c0 .5625.4375 1 1 1h2c.53125 0 1-.4375 1-1v-.5h4.5v3.5c0 .2812-.25.5-.5.5z",
		fill: "#005ce6"
	})
});
export { SvgWorkspaceFilled as ReactComponent };
